import { Skeleton } from "antd";
import { SkeletonInputProps, SkeletonProps } from "./type";

function AntSkeleton(props: SkeletonProps) {
  return <Skeleton {...props} />;
}
function AntSkeletonInput(props: SkeletonInputProps) {
  return <Skeleton.Input {...props} />;
}

export { AntSkeleton as Skeleton, AntSkeletonInput as SkeletonInput };
